// extracted by mini-css-extract-plugin
export default {"timer":"Spinner_timer__AI5pI","timerAnmiation":"Spinner_timerAnmiation__4rsAt","isCenter":"Spinner_isCenter__TYpwh"};